export default {
    excess: 'Atsakomybės riba',
    security: 'Užstatas',
    fuel_policy: 'Kuro politika',
    like_for_like: 'Toks pats už tokį patį',
    full_to_full: 'Pilnas iki pilno',
    mileage: 'Rida: {mileage} mylių nuomai',
    unlimited_mileage: 'Neribota rida',
    non_refundable: 'Negrąžinama',
    free_cancellation_until: 'Nemokamas atšaukimas iki {date}',
    cancellation_with_terms: 'Atšaukimas {0} pagal ',
    t_c_text: 'Taisyklės ir sąlygos',
    two_free_extras: 'Du nemokami priedai atsiėmimo metu',
    glass_tyres_covered: 'Stiklai ir padangos apdrausti',
    spec_fuel_petrol: 'benzinas',
    spec_fuel_petrol_diesel: 'benzinas/dyzelis',
};
